export const SET_SELECTED_ENTITY = "SET_SELECTED_ENTITY";
export const CLEAR_SELECTED_ENTITY = "CLEAR_SELECTED_ENTITY";
